import * as React from 'react'
import { ArgumentAxis, CommonSeriesSettings, Label, Legend, Series, SeriesTemplate, TickInterval } from 'devextreme-react/chart'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'
import { GroupByDate, GroupByDateType } from '../../../../components/GroupByDate'
import { resultDateTransformer } from '../../../../utils/date'
import { defaultGroupTypes } from 'components/grouping/views'

export const BannerChart: React.FunctionComponent = ({ }) => {
    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')
    const [groupBy, setGroupBy] = React.useState<string | undefined>('membership')

    const toolbarItems = GroupByType(defaultGroupTypes, groupBy, (selected) => {
        setGroupBy(selected)
    }).concat(GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    }))

    return (
        <BPMChart title='Banner Clicks' subTitle={groupBy ? `By ${groupBy.slice(0, 1).toUpperCase()}${groupBy.slice(1)}` : 'Total'} type='bar'
            additionalParams={{ groupDateBy, groupBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('browse/banner', options, signal))
            }} toolBarItems={() => toolbarItems}>
            {groupBy && <SeriesTemplate
                nameField={groupBy}
            />}
            {!groupBy && <Series name='Clicks' />}
            <CommonSeriesSettings type='bar'
                valueField="count"
                argumentField="date">
            </CommonSeriesSettings>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined}
                    weeks={groupDateBy == 'week' ? 1 : undefined}
                    months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>

            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Browse/charts/BannerChart.tsx